export default "__VITE_ASSET__6ce946d7__"